module.exports = "agm-map {\r\n    height: 550px;\r\n}\r\n\r\n::ng-deep .modal-dialog {\r\n    width: 370px;\r\n    /* max-width: 660px; */\r\n    margin: 90px auto;\r\n}\r\n\r\n::ng-deep .modal-backdrop.show {\r\n    background: #ffffff;\r\n    opacity: 0.9;\r\n}\r\n\r\n:host ::ng-deep .modal-content{\r\n  border-radius:0.1rem;\r\n  padding:20px;\r\n  -webkit-box-shadow: 5px 5px 50px #dfdfdf;\r\n          box-shadow: 5px 5px 50px #dfdfdf;\r\n  height: 660px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/map-popup/map-popup.component.css
// module id = ./src/app/shared/map-popup/map-popup.component.css
// module chunks = main